import { INCOMEIQUEUE_RCM_NETWORK_TABS } from 'lib/constants/healthcareProgram/incomeIQueueRcm';

import Typography from 'components/shared/Typography/Typography';
import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';

import IncomeIQueueStepSection from './IncomeIQueueStepSection';

const IncomeIQueueBody = ({
  activeNetwork,
  activeNetworkValues,
  onNetworkChange,
  onScenariosChange
}) => (
  <div className="flex w-full flex-1 flex-col items-center overflow-y-auto">
    <div className="flex w-full max-w-[770px] flex-col gap-5 px-4 py-6">
      <div className="flex flex-col gap-2">
        <Typography size="large" weight="medium">
          IncomeIQueue custom RCM setup
        </Typography>
        <Typography size="small" color="neutral-700">
          Automated suggested actions that appear in your IncomeIQueue. They&apos;re surfaced based
          on the scenario and the agreement with the patient, and remain as suggestions until you
          decide to act on them — select all or a subset of encounters and perform the suggested
          actions in seconds.
        </Typography>
      </div>

      <div className="h-[1px] w-full bg-neutral-200" />

      <SegmentedControl
        items={INCOMEIQUEUE_RCM_NETWORK_TABS}
        active={activeNetwork}
        onClick={onNetworkChange}
      />

      <IncomeIQueueStepSection
        networkType={activeNetwork}
        values={activeNetworkValues}
        onChange={onScenariosChange}
      />
    </div>
  </div>
);

export default IncomeIQueueBody;
